import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { AppConfig } from '../../../../../../../app.config';

import SignaturePad from 'signature_pad';
import moment from 'moment';

@Component({
  selector: 'app-rental-reservation-waiver',
  templateUrl: './rental-reservation-waiver.component.html',
  styleUrls: ['./rental-reservation-waiver.component.scss'],
})
export class RentalReservationWaiverComponent implements OnInit {
  @Input() reservation;
  @Input() rentalStoreRules: any = {};

  public waivers: any = [];
  public loading: boolean = false;
  public submitting: boolean = false;
  public countryData: any = {};
  public selectedWaiver: any = null;
  public waiverUrl: any = null;
  public busySending: boolean = false;

  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  public sig: SignaturePad;

  constructor(
    private rentalsService: RentalsService,
    private changeDetectorRef: ChangeDetectorRef,
    private helperService: HelpersService,
    private appConfig: AppConfig,
  ) {}

  ngOnInit() {
    this.countryData = this.helperService.getCountryData();
    this.waiverUrl =
      this.appConfig.getRentalWidgetURL() +
      '/rentals/waiver/' +
      this.reservation.webIdentifier +
      (this.appConfig.isDev() ? '?dev=true' : '');
    this.getExistingWaiver();

    this.changeDetectorRef.detectChanges();
    if (this.canvas) {
      this.sig = new SignaturePad(this.canvas.nativeElement);
    }
  }

  ngOnChanges() {}

  getExistingWaiver() {
    this.loading = true;
    this.rentalsService
      .getRentalReservationWaiver(
        this.reservation.defaultPartnerID,
        this.reservation.id,
      )
      .subscribe(
        (waivers) => {
          this.loading = false;
          this.waivers = waivers.map((x) => {
            return {
              ...x,
              birthDate: x.birthDate ? moment(x.birthDate).toDate() : null,
            };
          });
          if (this.waivers.length > 0) {
            this.selectedWaiver = this.waivers[0];
          }
          //this.setupCanvas();
          setTimeout(() => {
            this.changeDetectorRef.detectChanges();
            if (this.canvas) {
              this.sig = new SignaturePad(this.canvas.nativeElement);
            }
          }, 50);
        },
        (err) => {},
      );
  }

  selectWaiver(waiver) {
    this.selectedWaiver = waiver;
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
      if (this.canvas) {
        this.sig = new SignaturePad(this.canvas.nativeElement);
      }
    }, 50);
  }

  clear() {
    this.sig.clear();
  }

  clearSignature() {
    this.selectedWaiver = {
      ...this.selectedWaiver,
      waiverID: null,
      signatureURL: null,
      signatureDate: null,
    };
    this.changeDetectorRef.detectChanges();
    if (this.canvas) {
      this.sig = new SignaturePad(this.canvas.nativeElement);
    }
  }

  submitSignature() {
    this.submitting = true;
    var data = {
      ReservationID: this.reservation.id,
      ProductID: this.selectedWaiver.productID,
      Customer: this.selectedWaiver.customer,
      Email: this.selectedWaiver.email,
      BirthDate: this.selectedWaiver.birthDate,
      SignedDate: new Date(),
      WaiverTerms: this.rentalStoreRules.waiverTerms,
      SignatureData: this.canvas.nativeElement
        .toDataURL()
        .replace(/^data:(.*;base64,)?/, ''),
    };
    this.rentalsService.createReservationWaiver(data).subscribe(
      (waivers) => {
        this.waivers = waivers;
        if (this.selectedWaiver && this.selectedWaiver.productID) {
          this.selectedWaiver = waivers
            .filter((x) => {
              return x.productID === this.selectedWaiver.productID;
            })
            .pop();
        }
        this.submitting = false;
      },
      (err) => {
        this.submitting = false;
      },
    );
  }

  isSignatureValid() {
    return (
      this.selectedWaiver.customer &&
      this.selectedWaiver.email &&
      this.selectedWaiver.birthDate &&
      this.canvas &&
      this.canvas.nativeElement.toDataURL() !==
        'data:image/png;base64,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'
    );
  }

  resendWaiver(){
    this.busySending = true;
    var data = {
      PartnerID: this.reservation.defaultPartnerID,
      ReservationID: this.reservation.id,
    };
    this.rentalsService.resendReservationWaiver(data).subscribe(
      () => {        
        this.busySending = false;
      },
      (err) => {
        this.busySending = false;
      },
    );
  }
}
